import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WidgetGallery } from '../components/WidgetGallery';
import { About } from '../components/About';
import { ContactForm } from '../components/ContactForm';

export const Home = () => {
  return (
    <div data-testid="home-page">
      <Hero />
      <Services />
      <WidgetGallery />
      <ContactForm />
      <About />
    </div>
  );
};